import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Upload,
} from "antd";
import {
  ColumnsMappingIncome,
  ColumnsMappingIncomeCategoryExpend,
  ColumnsMappingIncomeCsv,
  ColumnsMappingIncomeExpend,
} from "./columns-table";
import { notificationErroInternal, notificationSucess } from "util/api-utils";
import {
  deleteCompanyMappingIncome,
  deleteCompanyMappingIncomeCategory,
  getCompanies,
  getCompanyCategoriesByCompanyId,
  getCompanyMappingIncome,
  putCompanyMappingIncome,
  saveCompanyMappingIncome,
} from "services/client/client-service";

import { ExclamationCircleFilled, SearchOutlined } from "@ant-design/icons";
import { saveMappingIncome } from "services/import/import-service";
import Highlighter from "react-highlight-words";
import { CSVLink } from "react-csv";

const { confirm } = Modal;

const MappingIncome = () => {
  const [loadingData, setLoadingData] = useState(true);
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const formRef = React.useRef(null);
  const [editId, setEditId] = useState(null);
  const [selectCompanyRes, setSelectCompany] = useState([]);
  const [selectCategory, setSelectCategory] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = React.useRef(null);
  const [dataCsv, setDataCsv] = useState([]);

  useEffect(() => {
    getMappingData();

    getCompanies()
      .then((res) => {
        let selectCompanyRes = res.map((obj) => ({
          value: obj.id,
          label: obj.name,
        }));
        setSelectCompany(selectCompanyRes);
      })
      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }, []);

  function edit(row) {
    showModal();
    setEditId(row.key);
    resetCategory(row.clientId);
    setTimeout(() => {
      formRef.current?.setFieldsValue({
        name: row.name,
        order: row.order,
        company: row.clientId,
        isTotal: row.isTotal,
        categories: row.mapping.map((obj) => obj.categoryId),
      });
    }, 300);
  }
  function disable(row) {
    confirm({
      title:
        "Tem certeza que deseja deletar todo mapeamento para '" +
        row.client +
        "' ?",
      icon: <ExclamationCircleFilled />,
      okText: "Sim",
      okType: "danger",
      cancelText: "Não",
      onOk() {
        setLoadingData(true);
        deleteCompanyMappingIncome(row.key)
          .then(() => {
            notificationSucess();
            getMappingData();
          })
          .catch((err) => {
            setLoadingData(false);
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde."
            );
          });
      },
      onCancel() {},
    });
  }
  function disableCategory(row) {
    confirm({
      title: "Tem certeza que deseja deletar '" + row.name + "' ?",
      icon: <ExclamationCircleFilled />,
      okText: "Sim",
      okType: "danger",
      cancelText: "Não",
      onOk() {
        setLoadingData(true);

        deleteCompanyMappingIncomeCategory(row.key)
          .then(() => {
            notificationSucess();
            getMappingData();
          })
          .catch((err) => {
            setLoadingData(false);
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde."
            );
          });
      },
      onCancel() {},
    });
  }
  function getMappingData() {
    getCompanyMappingIncome()
      .then((res) => {
        let mapping = [];
        res = res.map((obj) => ({ ...obj, disable: disable }));
        res.forEach((element) => {
          element.mapping.forEach((elementItem) => {
            elementItem.mapping.forEach((elementMap) => {
              const isTotalString = elementMap.isTotal ? "SIM" : "NÃO";
              elementMap.isTotalString = isTotalString;
            });
            mapping.push(...elementItem.mapping);
          });
          element.mapping = element.mapping.map((obj) => ({
            ...obj,
            edit: edit,
            disable: disableCategory,
          }));
        });
        setDataCsv(mapping);
        setLoadingData(false);
        setData(res);
      })
      .catch((err) => {
        setLoadingData(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    formRef.current
      .validateFields()
      .then((values) => {
        setLoadingData(true);
        setIsModalOpen(false);
        if (editId !== null) {
          put(values);
        } else {
          save(values);
        }
      })
      .catch((errors) => {
        console.log(errors);
      });
  };
  function save(values) {
    saveCompanyMappingIncome(values)
      .then(() => {
        notificationSucess();
        formRef.current?.resetFields();
        getMappingData();
      })
      .catch((err) => {
        setLoadingData(false);
        formRef.current?.resetFields();
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  function put(values) {
    values.id = editId;
    putCompanyMappingIncome(values)
      .then(() => {
        notificationSucess();
        formRef.current?.resetFields();
        setEditId(null);
        getMappingData();
      })
      .catch((err) => {
        setLoadingData(false);
        setEditId(null);
        formRef.current?.resetFields();
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  const handleCancel = () => {
    formRef.current?.resetFields();
    setIsModalOpen(false);
    setEditId(null);
  };
  function resetCategory(company) {
    getCompanyCategoriesByCompanyId(company)
      .then((res) => {
        let selectCategoryRes = res.map((obj) => ({
          value: obj.id,
          label: obj.name,
        }));
        setSelectCategory(selectCategoryRes);
      })
      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  const handleUpload = () => {
    setUploading(true);
    const formData = new FormData();
    formData.append("file", fileList[0]);
    saveMappingIncome(formData)
      .then(() => {
        setUploading(false);
        notificationSucess();
        getMappingData();

        setFileList([]);
      })
      .catch((err) => {
        setUploading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  };
  const props = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex, tittle) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Buscar ${tittle}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Limpar
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  let columnFilter = ColumnsMappingIncome.filter(
    (item) => item.dataIndex != "action"
  ).map((item) => ({
    ...item,
    ...getColumnSearchProps(item.dataIndex, item.title),
  }));
  const action = ColumnsMappingIncome.filter(
    (item) => item.dataIndex == "action"
  );
  columnFilter.push(action[0]);

  return (
    <div className="container-client">
      <Card
        className="card-client"
        title="Mapeamento DRE Gerencial"
        extra={
          <Space>
            <CSVLink
              filename={"plano_contas_dre.csv"}
              className="btn btn-primary"
              data={dataCsv}
              headers={ColumnsMappingIncomeCsv}
              style={{ borderRadius: "6px" }}
            >
              Baixar Dados
            </CSVLink>

            <a href="https://bussola-web.s3.amazonaws.com/importacao_plano_contas.xlsx">
              <Button
                style={{
                  display: fileList.length !== 0 ? "none" : "",
                }}
                type="primary"
              >
                Baixar templete
              </Button>
            </a>

            <Upload {...props}>
              <Button
                style={{
                  marginRight: "-9px",
                  display: fileList.length !== 0 ? "none" : "",
                }}
                type="primary"
                className="button-user"
                onClick={() => {}}
              >
                Nova Importação
              </Button>
            </Upload>
            <Button
              type="primary"
              onClick={handleUpload}
              disabled={fileList.length === 0}
              loading={uploading}
              style={{
                display: fileList.length === 0 ? "none" : "",
              }}
            >
              {"Salvar arquivo"}
            </Button>

            <Button
              type="primary"
              className="button-client"
              onClick={showModal}
              style={{
                display: fileList.length !== 0 ? "none" : "",
              }}
            >
              Novo Mapeamento
            </Button>
          </Space>
        }
        bordered={false}
      >
        <Spin spinning={loadingData} size={"large"}>
          <Table
            columns={columnFilter}
            dataSource={data}
            pagination={{ pageSize: 10 }}
            locale={{
              emptyText: "Sem registro",
            }}
            expandable={{
              expandedRowRender: (record) => (
                <Table
                  pagination={false}
                  dataSource={record.mapping}
                  columns={ColumnsMappingIncomeExpend}
                  expandable={{
                    expandedRowRender: (record) => (
                      <Table
                        pagination={false}
                        dataSource={record.mapping}
                        columns={ColumnsMappingIncomeCategoryExpend}
                      />
                    ),
                  }}
                />
              ),
            }}
          />
        </Spin>
      </Card>
      <Modal
        style={{ textAlign: "center" }}
        title="Novo Mapeamento"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={"100%"}
      >
        <Form ref={formRef}>
          <Row>
            <Form.Item
              name="company"
              label="Empresa"
              rules={[
                {
                  required: true,
                  message: "É necessário informar uma empresa",
                },
              ]}
              style={{ marginLeft: "10px", width: "350px" }}
            >
              <Select
                allowClear
                onChange={resetCategory}
                style={{
                  width: "100%",
                }}
                options={selectCompanyRes}
              />
            </Form.Item>

            <Form.Item
              name="name"
              label="Nome"
              rules={[
                { required: true, message: "É necessário informar o nome" },
              ]}
              style={{ marginLeft: "10px" }}
            >
              <Input style={{ width: "350px" }} />
            </Form.Item>
            <Form.Item
              name="order"
              label="Ordem"
              rules={[
                { required: true, message: "É necessário informar a ordem" },
              ]}
              style={{ marginLeft: "10px" }}
            >
              <InputNumber style={{ width: "93%" }} />
            </Form.Item>
            <Form.Item
              name="isTotal"
              label="É totalizador?"
              rules={[
                {
                  required: true,
                  message: "É necessário informar o totalizador",
                },
              ]}
              style={{ marginLeft: "10px" }}
            >
              <Select style={{ width: "100%" }} onChange={(e) => setIsTotal(e)}>
                <Option value={true}>Sim</Option>
                <Option value={false}>Não</Option>
              </Select>
            </Form.Item>
          </Row>
          <Row>
            <Form.Item
              name="categories"
              label="Categorias"
              rules={[
                {
                  required: true,
                  message: "É necessário informar uma categoria",
                },
              ]}
            >
              <Select
                mode={"multiple"}
                allowClear
                style={{
                  width: "100%",
                }}
                options={selectCategory}
              />
            </Form.Item>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};
export default MappingIncome;
